<app-label-inflator
  #labelCalculator
  hidden
  class="label-calculator"
  [calculateVirtualLabel]="true"
  [columnLabel]="false"
  [labelComponentInterface]="data"
  [reset]="false">
</app-label-inflator>
<div class="main-content">
  <div class="top-container">
    <img
      *rxIf="data | getVariantAssetForCard | push as variantAsset; else fallbackImage"
      appImage
      class="brand-logo"
      [asset]="variantAsset"
      src=""
      alt="" />
    <ng-template #fallbackImage>
      <img
        *rxIf="viewModel.cardAssetUrl$ | async as cardAssetUrl"
        class="product-image"
        [src]="cardAssetUrl"
        alt="product image" />
    </ng-template>
    <div class="product-name-brand-and-properties">
      <div *rxIf="viewModel.hasPropertiesBasedOnPools$; strategy: 'immediate'" class="properties-container">
        <div
          appPrintCardScaleDownText
          [maxHeightInPx]="16"
          [maxWidthInPx]="265"
          [useFloatingPointPixels]="true"
          [decrementFontSizeByNPixelsPerStep]="0.1"
          [adjustLineHeight]="false"
          [transparentWhileScaling]="true"
          class="product-cannabinoids-container"
          [style.color]="viewModel.bodyTextColor$ | push">
          <ng-container *rxFor="let propertyData of viewModel.propertiesBasedOnPools$; strategy: 'immediate'">
            <div class="cannabinoid">
              <div class="cannabinoid-title">{{ propertyData?.title }}</div>
              <div class="cannabinoid-value">{{ propertyData?.value }}</div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="product-brand-image-and-product-info">
        <div class="product-brand-and-product">
          <div
            *rxIf="
              !(data | getVariantAssetForCard | push) && (data | sectionRowViewModelBasicMethod: 'getBrand') as brand
            "
            class="product-card-brand"
            appPrintCardScaleDownText
            [maxHeightInPx]="16"
            [maxWidthInPx]="265"
            [useFloatingPointPixels]="true"
            [decrementFontSizeByNPixelsPerStep]="0.1"
            [adjustLineHeight]="false"
            [transparentWhileScaling]="true"
            [style.color]="viewModel.headerTextColor$ | push">
            {{ brand }}
          </div>
          <div
            #productCardName
            class="product-card-name"
            appPrintCardScaleDownText
            [maxHeightInPx]="28"
            [maxWidthInPx]="265"
            [useFloatingPointPixels]="true"
            [decrementFontSizeByNPixelsPerStep]="0.1"
            [adjustLineHeight]="false"
            [transparentWhileScaling]="true"
            [style.color]="viewModel.headerTextColor$ | push">
            {{ data | sectionRowViewModelBasicMethod: 'getRowTitle' | trimSafely }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="bottom-container">
    <hr
      class="card-separator"
      [style.background-color]="(viewModel.cardAccentColor$ | push) || (viewModel.bodyTextColor$ | push)" />

    <div class="product-card-info">
      <div class="left-side">
        <div class="product-card-badge-and-label-container">
          <img
            *rxFor="let variantBadge of data | printCardBadges"
            appImage
            class="product-card-badge"
            [asset]="variantBadge?.image"
            alt="badge"
            src="" />
          <app-label-inflator
            class="print-card-label"
            [columnLabel]="false"
            [labelComponentInterface]="data"
            [reset]="false">
          </app-label-inflator>
        </div>

        <div class="strain-and-quantity-container" [style.color]="viewModel.bodyTextColor$ | push">
          <div *rxIf="viewModel.strainText$ | push as strainType" class="product-card-strain-type">
            {{ strainType }}
          </div>
          <div
            *rxIf="(viewModel.strainText$ | push) && (viewModel.productSizeExists$ | push)"
            class="product-card-strain-quantity-separator">
            |
          </div>
          <div *rxIf="viewModel.productSize$ | push as size" class="product-card-quantity">
            {{ size }}
          </div>
        </div>
      </div>

      <div class="product-card-price-container" [style.color]="viewModel.bodyTextColor$ | push">
        <app-column-primary-price
          [menu]="viewModel.cardStackMenu$ | push"
          [section]="viewModel.cardStack$ | push"
          [colVm]="viewModel.spoofedColViewModel$ | push"
          [rowVm]="viewModel.cardData$ | push"
          [locConfig]="viewModel.locationConfig$ | push"
          [locationId]="viewModel.locationId$ | push"
          [productStylingVm]="viewModel"
          [leadingTextOriginalPriceWithSale]="'WAS '"
          [leadingTextSalePrice]="'NOW '"
          [includeLineThroughOnLeadingTextOriginalPriceWithSale]="false"
          [ignoreStylingForSaleText]="false">
        </app-column-primary-price>
      </div>
    </div>
  </div>
</div>
